import React, { useEffect, useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import useItemRequestContext from 'contexts/item-request.context/context';
import { useNavigate, useParams } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

import MainstoreRequestItemReceive from 'components/mainstore- request-item-receive';

const ReceiveItems = () => {
  const router = useNavigate();
  const { itemRequestToEdit, setItemRequestToEdit } = useItemRequestContext();
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const { ids } = useParams();
  const [editedItems, setEditedItems] = useState({});

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to item requests');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  useEffect(() => {
    setItemRequestToEdit((prev) => ({
      ...prev,
      items: prev.items.map((itemToUpdate) => ({
        ...itemToUpdate,
        new_quantity_sent: itemToUpdate.quantity_sent
      }))
    }));
  }, []);

  const handleUpdate = async () => {
    const data = {
      items: editedItems
    };
    try {
      setLoading(true);
      const res = await apiService.post(
        `kitchen-store/kitchen-request/${itemRequestToEdit?.id}/send-items`,
        {
          data
        }
      );
      if (res) {
        toast(<ToastMessage type='success' message=' Update successful' />);
        router(-1);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className='border-4 border-[#F7F7F8] rounded py-[24px]  md:max-w-[670px]'>
        <div className='flex justify-between px-[28px]'>
          <div className=' pb-5'>
            <p className='font-semibold text-[24px]'>Update received items </p>
            <p className='text-[#6F7376] text-sm'>
              State the quantity received in good condition where necessary
            </p>
          </div>
        </div>
        {itemRequestToEdit?.items
          ?.filter((item) => ids?.includes(item.id))

          ?.sort((a, b) => a.quantity - b.quantity)
          ?.map((item) => (
            <MainstoreRequestItemReceive key={item.id} item={item} onItemChange={setEditedItems} />
          ))}
        <div>
          <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
            <Button variant='link' color='gray' small onClick={() => router(-1)}>
              Back
            </Button>
            <Button
              variant='block'
              color='primary'
              small
              className='w-[153px] h-[43px]'
              onClick={handleUpdate}
              loading={loading}
              disabled={
                itemRequestToEdit?.items?.some((item) => item.new_quantity_sent > item.quantity) ||
                loading
              }>
              Update
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiveItems;
